import { InputGroup, Input, InputLeftElement } from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";

const TableTextFilter = ({
    column: { filterValue, setFilter },
}) => (
    <InputGroup size="xs">
        <InputLeftElement
            pointerEvents='none'
            children={<SearchIcon color='gray.400' />}
        />
        <Input
            value={filterValue || ''}
            onChange={e => {
                setFilter(e.target.value || undefined) // Set undefined to remove the filter entirely
            }}
            placeholder={`Search..`}
        />
    </InputGroup>
);

export default TableTextFilter;